import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import IESocialDock from './IEFriends'; // THE SOCIAL LAYER — self-identifying, follows the player across every screen. See IEFriends.js.
import Mark from './Mark'; // THE MARK — wired into the social dock's MarkView slot

// NOTE: no StrictMode here, deliberately. StrictMode double-invokes effects
// in development, which is harmless for most screens but makes an audio
// engine look haunted — listeners registered twice, a play counted twice,
// a restore racing itself. The engine lives outside React precisely so it
// is not at the mercy of render behaviour; leaving StrictMode off keeps
// development sounding like production.
ReactDOM.createRoot(document.getElementById("root")).render(
  <>
    <App />
    <IESocialDock game="lyraea" accent="#ec4899" MarkView={Mark} />
  </>
);
